import React from 'react'
import './Cookies.css'

function Cookies() {
    return (
        <div className='degradado'>
            <div className="nosotros dos">
                <h2 id='dron' className='subtitulo tres'>
                    POLÍTICA DE COOKIES
                </h2>
            </div>
            
                <p className='cooki'>Nuestro sitio solo utiliza cookies estrictamente necesarias para el funcionamiento del 
                formulario de contacto y la navegación en el sitio. No se utilizan cookies de seguimiento ni de marketing.</p>
            
            
        </div>
    )
}

export default Cookies
